import React from 'react';
import { Row, Col, Typography, Skeleton } from 'antd';
import { withTranslation } from 'react-i18next';
import { Bar } from 'react-chartjs-2';
import { DonutWithLegend } from './ChartShared';
import Colors from '../../../../../themes/Colors';
import { resolveColor } from '../../../../../themes/theme';

const { Text, Title } = Typography;

const individualCardStyle = {
  backgroundColor: Colors.snow,
  border: `1px solid ${Colors.border}`,
  borderRadius: '12px',
  padding: '20px',
  height: '220px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center'
};

const titleContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginBottom: '12px'
};

const titleStyle = { margin: 0, fontSize: '16px', fontWeight: 'bold' };

// Función (no constante) para tomar el color de texto del tema activo al renderizar
const getHorizontalBarOptions = () => ({
  indexAxis: 'y',
  responsive: true,
  maintainAspectRatio: false,
  plugins: { legend: { display: false } },
  scales: {
    x: {
      stacked: true,
      grid: { display: false },
      ticks: { font: { size: 10 }, color: resolveColor(Colors.textMuted) }
    },
    y: {
      stacked: true,
      grid: { display: false },
      ticks: { font: { size: 11 }, color: resolveColor(Colors.black) }
    }
  }
});

const StackedBarWithLegend = ({ data, loading, emptyMessage }) => {
  if (loading) return <Skeleton active paragraph={{ rows: 4 }} />;
  if (!data)
    return (
      <div
        style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Text type="secondary">{emptyMessage}</Text>
      </div>
    );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '10px',
          marginBottom: '10px',
          justifyContent: 'center'
        }}
      >
        {data.datasets.map((dataset, index) => (
          <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
            <span
              style={{
                width: '10px',
                height: '10px',
                backgroundColor: dataset.backgroundColor,
                marginRight: '5px',
                borderRadius: '2px'
              }}
            />
            <Text type="secondary" style={{ fontSize: '10px' }}>
              {dataset.label}
            </Text>
          </div>
        ))}
      </div>
      <div style={{ flex: 1, position: 'relative' }}>
        <Bar data={data} options={getHorizontalBarOptions()} />
      </div>
    </div>
  );
};

const InvestmentCharts = ({
  loading,
  investmentByTypeData,
  investmentBySubtypeData,
  investmentByMediaOwnerData,
  t
}) => {
  return (
    <div>
      <Row gutter={[24, 24]}>
        <Col xs={24} lg={8}>
          <div style={titleContainerStyle}>
            <Title level={5} style={titleStyle}>
              {t('Investment by screen type')}
            </Title>
          </div>
          <div style={individualCardStyle}>
            <DonutWithLegend
              data={investmentByTypeData}
              loading={loading}
              emptyMessage={t('No data available')}
            />
          </div>
        </Col>

        <Col xs={24} lg={8}>
          <div style={titleContainerStyle}>
            <Title level={5} style={titleStyle}>
              {t('Investment by screen subtype')}
            </Title>
          </div>
          <div style={individualCardStyle}>
            <StackedBarWithLegend
              data={investmentBySubtypeData}
              loading={loading}
              emptyMessage={t('No data available')}
            />
          </div>
        </Col>

        <Col xs={24} lg={8}>
          <div style={titleContainerStyle}>
            <Title level={5} style={titleStyle}>
              {t('Investment by media owner')}
            </Title>
          </div>
          <div style={individualCardStyle}>
            <DonutWithLegend
              data={investmentByMediaOwnerData}
              loading={loading}
              emptyMessage={t('No data available')}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default withTranslation()(InvestmentCharts);
